export const DEFAULT_APPEARANCE_SETTINGS = {
    animationsEnabled: true,
};
//# sourceMappingURL=appearance-settings.js.map